import React from 'react'
import { StockReportsSummaryDataType, TotalStockReportsSummaryDataType } from '../../../../redux/reports/reportsType'
import { TableLoader } from '../../../commons'
import StockReportsSummaryTableData from './StockReportsSummaryTableData';
import StockReportsSummaryTableHeader from './StockReportsSummaryTableHeader';

type AppProps = {
  fetching: boolean;
  client_code: number;
  startDate: string;
  endDate: string;
  company_name: string;
  currencySign: string | undefined;
  stockReportsSummaryData: [] | StockReportsSummaryDataType[];
  totalStockReportsSummaryData: TotalStockReportsSummaryDataType;
}

const StockReportsSummaryTable = ({
  fetching,
  client_code,
  stockReportsSummaryData,
  totalStockReportsSummaryData,
  startDate,
  endDate,
  company_name,
  currencySign
}: AppProps) => {

  return (
    <div >
      {
        fetching ?
          <TableLoader
            Rows={10}
            ColumnPerRow={8}
          /> :
          <div className="jobsType" style={{ overflowX: "scroll" }}>
            <table className="table table-bordered thead-light">
              <thead className='text-start'>
                <StockReportsSummaryTableHeader />
              </thead>
              <tbody>
                <StockReportsSummaryTableData
                  stockReportsSummaryData={stockReportsSummaryData}
                  totalStockReportsSummaryData={totalStockReportsSummaryData}
                  client_code={client_code}
                  company_name={company_name}
                  startDate={startDate}
                  endDate={endDate}
                  currencySign={currencySign}
                />
              </tbody>
            </table>
          </div>
      }
    </div>
  )
}

export default StockReportsSummaryTable